// add your site specific javascript here
$( document ).ready(function() {
	'use strict';

	$.ajaxSetup( {
		cache: true
	} );

	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}

	//Return to top
	$( window ).scroll( function() {
		if ( $( this ).scrollTop() > 200) {        // If the page is scrolled more than 200px
			$( '#return-to-top' ).fadeIn( 200 );
		} else {
			$( '#return-to-top' ).fadeOut( 200 );
		}
	});
	$( '#return-to-top' ).click( function() {
		console.log("clicked button!");
		$( 'body,html' ).animate({
			scrollTop : 0
		}, 500);
	});

	var $searchContainer = $( '#searchContainer' );
	$( '[data-zg-role="btn-search"]' ).click( function(){
		if( $searchContainer.hasClass( 'd-none' ) ){
			$searchContainer.removeClass( 'd-none' );
		}
		else {
			$searchContainer.addClass( 'd-none' );
		}
	});


	//Increasing-decreasing qty input
	$( '[data-zg-role="change-qty"]' ).click( function(){
		event.preventDefault();
		var type = $( this ).data( 'type' );
		var $inputQtySibling = $( this ).parent().siblings( '[data-zg-role="quantity"]' );
		var maxQty = $inputQtySibling.data( 'max' );
		var floatQty = $inputQtySibling.data( 'floatQty' );
		var qty = $inputQtySibling.val();
		var step;

		if( floatQty ){
			step = 0.01;
		}
		else {
			step = 1;
		}
		qty = Number(qty);

		$( '[data-zg-role="change-qty"]' ).attr( 'disabled', false );
		if( type == "minus" ){
			//If qty is 0, we will disable the current minus icon.
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == 0 ){
				$( this ).attr( 'disabled', true );
			}
			else{
				qty = qty - step;
			}
		}
		else {
			//If qty is equal to maxQty, we will disable the current plus icon.
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == maxQty ){
				$( this ).attr( 'disabled', true );
			}
			else {
				qty = qty + step;
			}
		}

		$( this ).parent().siblings( '[data-zg-role="quantity"]' ).val( qty );
	});
	
	/**
	 CUSTOM
	**/
	
	var swiper = new Swiper('.client-logos-slider', {
    wrapperClass: 'client-logos-wrapper',
    slideClass: 'client-logo',
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.client-logos-next',
      prevEl: '.client-logos-prev'
    },
    breakpoints: {
      576: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      },
      1200: {
        slidesPerView: 4
      }
    }
  });

  var swiperHero = new Swiper('.hero-slider', {
    wrapperClass: 'hero-slider-wrapper',
    slideClass: 'hero-slide',
    loop: true,
		navigation: {
      nextEl: '.slider-button-next',
      prevEl: '.slider-button-prev',
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    }
  });

	$(document).on("click","#calendarTest",function(e) {
		console.log('click');
		Calendly.initPopupWidget({url:'https://calendly.com/ccarusogoglobalecommerce/30min'});
		e.preventDefault();
	});

	
		
	new WOW().init();

	
		
	if ( $('#form_pdf').length ) {

		

		var email = $("[data-email='input-email']"),
		 	className = email.attr('id'),
		 	element = email.closest( '.form-group' ),
		 	isCommercialEmail = false;

			 
	
		email.on('keyup focusout', function() {
			
			checkNonCommercialEmail();
			setButtonStatus();
		});
		

	

		
		function checkNonCommercialEmail() {
		
			var patternEliminateNonCommercial = /^([\w\-.]+@(?!gmail.[a-z])(?!yahoo.[a-z])(?!hotmail.[a-z])(?!aol.[a-z])(?!abc.[a-z])(?!xyz.[a-z])(?!pqr.[a-z])(?!rediffmail.[a-z])(?!live.[a-z])(?!outlook.[a-z])(?!me.[a-z])(?!msn.[a-z])(?!ymail.[a-z])([\w-]+.)+[\w-]{1,4})?$/,

			patternCheckEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;// I have to check also if is a valid email because is not possible to use jquery validator
			

			if( patternEliminateNonCommercial.test( email.val() ) && patternCheckEmail.test( email.val() ) ){
				console.log('valid');
				if( checkErrorMsg(element) ) {
					element.children('.help-block.custom').remove();
				} 
				//replicate JQuery validation when is empty
				if ( email.val() == "" ){
					element.children('.help-block').remove();
					createErrorMsg(className,element,JS_TRANSLATIONS.field_required);
					isCommercialEmail = false;
				}else {
					isCommercialEmail = true;
				}

			} else {
				console.log('not valid');
				element.children('.help-block').remove();
				createErrorMsg(className,element,JS_TRANSLATIONS.commercial_email);
				isCommercialEmail = false;
			}
		
		}

		function checkErrorMsg(element) {
			var elementFinded = element.children('.help-block'),
				valueReturned = false;
			if(elementFinded.length > 0) {
				valueReturned = true;
			}
			return valueReturned;

		}

		function createErrorMsg(className,element,msg) {
			var html = `<span id="${className}-error" class="help-block custom">${msg}</span>`;
			element.append(html);
		}

		$('[data-zg-role="fields-check"]').on( 'keyup focusout', function( event ) {

			var excludedKeys = [
				16, 17, 18, 20, 35, 36, 37,
				38, 39, 40, 45, 144, 225
			];

			var code = ( event.keyCode || event.which );

			if(  $.inArray( code, excludedKeys ) !== -1 ) {
				return;
			} else {
				setButtonStatus();
			}

		} );

		$('.acceptPrivacyClass').on( 'change',  setButtonStatus );

		function setButtonStatus(){
			var empty = checkConditionsToActivateButton();
			if (empty) {
				$('.btn-download').addClass('disabled');
				$('.btn-download').attr('disabled', true);
				
			} else {

				if ($('#acceptPrivacy').length != 0) {
					if ($('input.acceptPrivacyClass').is(':checked')){
						$('.btn-download').attr('disabled', false);
						$('.btn-download').removeClass('disabled');
					} else {
						$('.btn-download').addClass('disabled');
						$('.btn-download').attr('disabled', true);
					}
				}
			}
		}

		function checkConditionsToActivateButton() {

			var empty = false;
			
			$('[data-zg-role="fields-check"]').each(function () {
				if ($(this).val().length == 0 ) {
					empty = true;
					
				}
			});

			if( isCommercialEmail == false) {
				empty = true;
			}

			return empty;

		}


	}

	$('#form_pdf').submit(function(e) {
		if ($(this).valid()){
    	document.getElementById('link').click();
		}
	});

	$('#inlineRadio6').change(function(){
		//event.preventDefault();
		var checked = $(this).is(':checked');
		var input = $('#otherOption');
		input.prop('required', checked);

	})

	$('.form-check-input').change(function(){
		$('#otherOption').removeAttr('required');
	})

	$( '#sendEmailSubmit' ).click(function() {
		$('#collapseHdyfu').addClass('show')
	});
	
});
